import { useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { Menu, X, Plane } from 'lucide-react'
import { clsx } from 'clsx'
import { useFranchiseData } from '../hooks/useFranchiseData'

const navigation = [
  { name: 'Home', href: '/' },
  { name: 'About', href: '/about' },
  { name: 'Holiday Packages', href: '/packages' },
  { name: 'Blog', href: '/blog' },
  { name: 'Contact us', href: '/contact' },
]

export default function Navbar() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
  const location = useLocation()
  const { franchiseData, loading } = useFranchiseData()

  // Show loading state or fallback
  if (loading || !franchiseData) {
    return (
      <header className="bg-white shadow-sm border-b border-gray-200">
        <nav className="mx-auto flex max-w-7xl items-center justify-between p-6 lg:px-8">
          <div className="flex lg:flex-1">
            <div className="animate-pulse flex items-center space-x-2">
              <div className="h-8 w-8 bg-gray-300 rounded"></div>
              <div className="h-6 w-32 bg-gray-300 rounded"></div>
            </div>
          </div>
        </nav>
      </header>
    )
  }

  return (
    <header className="bg-white shadow-sm border-b border-gray-200">
      <nav
        className="mx-auto flex max-w-7xl items-center justify-between p-6 lg:px-8"
        aria-label="Global"
      >
        <div className="flex lg:flex-1">
          <Link to="/" className="-m-1.5 p-1.5 flex items-center" style={{ overflow: 'visible' }}>
            <img
              src="/CT-HORIZONTAL-LOGO-BLUE.png"
              alt="Chelsea Travel Logo"
              className="h-28 w-auto"
              style={{ transform: 'scale(1.4)', marginTop: '-24px', marginBottom: '-24px' }}
            />
          </Link>
        </div>
        <div className="flex lg:hidden">
          <button
            type="button"
            className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-gray-700"
            onClick={() => setMobileMenuOpen(true)}
          >
            <span className="sr-only">Open main menu</span>
            <Menu className="h-6 w-6" aria-hidden="true" />
          </button>
        </div>
        <div className="hidden lg:flex lg:gap-x-12">
          {navigation.map((item) => (
            <Link
              key={item.name}
              to={item.href}
              className={clsx(
                'text-sm font-semibold leading-6 transition-colors hover:text-[#58b8cd]',
                location.pathname === item.href ? 'text-[#58b8cd]' : 'text-gray-900'
              )}
            >
              {item.name}
            </Link>
          ))}
        </div>
        <div className="hidden lg:flex lg:flex-1 lg:justify-end">
          <a
            href="/contact"
            className="btn bg-[#58b8cd] text-white text-base font-semibold px-6 py-2 rounded-md shadow hover:opacity-90 transition"
          >
            Plan My Dream Trip
          </a>
        </div>
      </nav>

      {/* Mobile menu */}
      {mobileMenuOpen && (
        <div className="lg:hidden" role="dialog" aria-modal="true">
          <div className="fixed inset-0 z-50"></div>
          <div className="fixed inset-y-0 right-0 z-50 w-full overflow-y-auto bg-white px-6 py-6 sm:max-w-sm sm:ring-1 sm:ring-gray-900/10">
            <div className="flex items-center justify-between">
              <Link to="/" className="-m-1.5 p-1.5 flex items-center">
                <img
                  src="/CT-HORIZONTAL-LOGO-BLUE.png"
                  alt="Chelsea Travel Logo"
                  className="h-10 w-auto"
                />
              </Link>
              <button
                type="button"
                className="-m-2.5 rounded-md p-2.5 text-gray-700"
                onClick={() => setMobileMenuOpen(false)}
              >
                <span className="sr-only">Close menu</span>
                <X className="h-6 w-6" aria-hidden="true" />
              </button>
            </div>
            <div className="mt-6 flow-root">
              <div className="-my-6 divide-y divide-gray-500/10">
                <div className="space-y-2 py-6">
                  {navigation.map((item) => (
                    <Link
                      key={item.name}
                      to={item.href}
                      className={clsx(
                        '-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 hover:bg-chelsea-orange hover:text-white transition',
                        location.pathname === item.href
                          ? 'text-white bg-chelsea-orange'
                          : 'text-gray-900'
                      )}
                      onClick={() => setMobileMenuOpen(false)}
                    >
                      {item.name}
                    </Link>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </header>
  )
}
